import { useNavigate } from 'react-router-dom';
import { TBreadcrumbsProps } from './Breadcrumbs.type';
import './Breadcrumbs.scss';

const Breadcrumbs = (props: TBreadcrumbsProps) => {
  const navigate = useNavigate();
  const { selected_Tab, handleClickAction } = props;
  const handleNavigate = () => {
    handleClickAction && handleClickAction();
    navigate('/search');
  };

  return (
    <div className="Breadcrumbs_Container">
      <span onClick={() => handleNavigate()}>
        {selected_Tab === 'FavoriteSearch' ? 'Favorite Search' : 'Recent Search'}
      </span>
      <img src="/oo/assets/icon/chevron-forward-outline.svg" alt="Breadcrumb icon" /> See Results
    </div>
  );
};

export default Breadcrumbs;
